import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 12l-10 0","key":"svg-0"}],["path",{"d":"M20 12l-4 4","key":"svg-1"}],["path",{"d":"M20 12l-4 -4","key":"svg-2"}],["path",{"d":"M4 4l0 16","key":"svg-3"}]]

const IconArrowBarRight = createReactComponent('outline', 'arrow-bar-right', 'ArrowBarRight', __iconNode);

export default IconArrowBarRight;